import AppPaths from '../AppPaths';

const SHOP_PATH = new RegExp(`^(/[a-z]{2}(-[a-z]{2})?)?${AppPaths.Shop}$`);

/**
 * Whether the router is on the shop. Main also serves the shop under each language's URL tree
 * (`/de/shop`, `/fr-ca/shop`) and renders legacy components there, which see that prefixed path.
 * The language segment is matched by its shape because legacy must not import main's locale list.
 */
export function isShopPath(pathname: string) {
  return SHOP_PATH.test(pathname);
}
